import styled from 'styled-components';
import { COLORS, FONT_FAMILY, FONTS } from 'utils/styles';
import { BREAKPOINTS } from 'admin/utils/breakpoints';

export const ProfileModalWrapper = styled.div`
  border-radius: 8px;
  width: 274px;
  height: 208px;
  background: ${COLORS.darkMainColor};
  padding: 30px 26px;

  @media only screen and ${BREAKPOINTS.laptop} {
    height: 240px;
  }
`;

export const ProfileMainInfo = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  height: 74px;
  border-bottom: 2px solid ${COLORS.lightSilver};

  @media only screen and ${BREAKPOINTS.laptop} {
    display: none;
  }
`;

export const ProfilePicture = styled.img`
  width: 46px;
  height: 46px;
  border-radius: 100%;
`;

export const ProfileUserInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: max-content;
`;

export const ProfileUserName = styled.span`
  ${FONTS.font18};
  ${FONT_FAMILY.FontRegular};
  color: ${COLORS.white};
`;

export const ProfileUserEmail = styled.span`
  color: ${COLORS.darkGray};
  ${FONTS.font14};
  ${FONT_FAMILY.FontRegular};
`;

export const ProfileSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-top: 24px;
  height: max-content;
`;

export const ProfileSection = styled.span`
  width: 100%;
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  color: ${COLORS.white};
  cursor: pointer;
`;

export const ModalWrapper = styled.div`
  position: relative;
  width: 540px;
  height: ${({ isDeleteModal }) => (isDeleteModal ? '333px' : '276px')};
  background: ${COLORS.white};
  border-radius: 8px;
  padding: 32px;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ isLogOut }) => (isLogOut ? '20px' : '20px')};
  width: 100%;
`;

export const CloseModalIcon = styled.img`
  width: 12px;
  height: 12px;
  position: absolute;
  top: 22px;
  right: 22px;
  cursor: pointer;
`;

export const ConfirmPasswordText = styled.span`
  color: ${COLORS.black};
  ${FONTS.font18};
  ${FONT_FAMILY.FontMedium};
`;

export const ForYourSecurityText = styled.span`
  color: ${COLORS.lightSilver};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
`;

export const InputWithButtons = styled.form`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  height: 124px;
`;

export const PasswordInput = styled.input`
  width: ${({ isLogOut }) => (isLogOut ? '464px' : '100%')};
  height: 46px;
  background: ${COLORS.whiteLite};
  border-radius: 8px;
  padding-left: 12px;
`;

export const CancelAndSaveButtons = styled.div`
  padding-inline: 56px;
  display: flex;
  gap: 24px;
  width: 100%;
`;

export const CancelButton = styled.button`
  width: 172px;
  height: 46px;
  border: 1px solid ${COLORS.mainColor};
  border-radius: 8px;
  color: ${COLORS.mainColor};
`;

export const SaveButton = styled.button`
  width: 172px;
  height: 46px;
  background: ${COLORS.mainColor};
  border-radius: 8px;
  color: ${COLORS.white};
`;

export const PasswordAndLogOutButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
`;

export const LogOutBrowserSessionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 46px;
`;

export const LogOutButton = styled.button`
  width: 264px;
  background: ${COLORS.mainColor};
  height: 46px;
  border-radius: 8px;
  color: ${COLORS.white};
`;
